import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import classNames from 'classnames';

import Button from './Button';

import centerImg from '../images/explanation-1.svg';

class Explanation extends Component {
  constructor(props) {
    super(props);

    this.activateButton = this.activateButton.bind(this);
    this.deactivateButton = this.deactivateButton.bind(this);

    this.state = {
      isButtonActive: false
    };
  }

  activateButton() {
    this.setState({
      isButtonActive: true
    });
  }

  deactivateButton() {
    this.setState({
      isButtonActive: false
    });
  }

  render() {
    const { onclick, history } = this.props;
    return (
      <div className="container mobile-center-adj vertical-horizontal-center full-width">
        <div className="row">
          <div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 text-center">
            <CSSTransitionGroup
              transitionName="fade"
              transitionAppear
              transitionEnter={false}
              transitionLeave={false}
              transitionAppearTimeout={800}
            >
              <div className="dialog dialog-bubble horizontal-center">
                和平常一樣，妳帶著錢包出門，突然看到了一些標語，然後它就死掉了...
              </div>
            </CSSTransitionGroup>
          </div>
        </div>
        <CSSTransitionGroup
          transitionName="fade-delay-1"
          transitionAppear
          transitionEnter={false}
          transitionLeave={false}
          transitionAppearTimeout={1800}
        >
          <div className="row margin-top-lg">
            <div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-4 col-md-offset-4 text-center">
              <div className="grain">
                <img
                  src={centerImg}
                  className="img-responsive"
                  alt="Fainting figure"
                />
              </div>
            </div>
          </div>
          <div className="row margin-top-lg">
            <div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 text-center">
              <div className="dialog horizontal-center padding-sm padding-no">
                <p className="margin-no">
                  這是監視器拍到它的最後身影，快根據直覺，透過以下測驗，
                  找出錄影帶，看妳的錢包是怎麼死的！
                </p>
              </div>
            </div>
          </div>
        </CSSTransitionGroup>
        <div className="row margin-top-md margin-sm-top-xl margin-bottom-lg">
          <div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 text-center">
            <CSSTransitionGroup
              transitionName="fade-delay-2"
              transitionAppear
              transitionEnter={false}
              transitionLeave={false}
              transitionAppearTimeout={2800}
            >
              <Button
                className={classNames(
                  'btn',
                  'btn-default'
                )}
                onClick={() => {
                  const start = (new Date()).getTime();
                  onclick({ id: 1, start });
                  history.push('/test/1');
                }}
              >
                出發
              </Button>
            </CSSTransitionGroup>
          </div>
        </div>
      </div>
    );
  }
}

Explanation.propTypes = {
  onclick: PropTypes.func.isRequired,
  history: PropTypes.shape().isRequired
};

export default Explanation;



// WEBPACK FOOTER //
// ./app/components/Explanation.js